import { useState, useEffect } from "react";
import Button from '../../../components/button/button';
import Input from '../../../components/input/input';
import Label from '../../../components/label/label';
import { useSettings } from "../../../hooks/useSettings";
import { formatIban, cleanIban } from "../../../utils/formatIban";


function Company() {
    const { fetchData, data, saveCompanyData } = useSettings();
    const [show, setShow] = useState(true);
    const [edit, setEdit] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [photo, setPhoto] = useState(null);
    const [website, setWebsite] = useState('');
    const [bank, setBank] = useState('');
    const [iban, setIban] = useState('');
    const [bic, setBic] = useState('');
    const [taxNumber, setTaxNumber] = useState('');
    const [taxOffice, setTaxOffice] = useState('');

    useEffect(() => {
        fetchData();
    }, []);

    const handleEdit = () => {
        setEdit(true);
        setShow(false);
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setEdit(false);
        setShow(true);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        formData.append('companyName', companyName);
        formData.append('website', website);
        formData.append('bank', bank);
        formData.append('iban', cleanIban(iban));
        formData.append('bic', bic);
        formData.append('taxNumber', taxNumber);
        formData.append('taxOffice', taxOffice);
        
        if (photo) {
            formData.append('photo', photo); 
        }

        saveCompanyData(e, formData);
        
        setEdit(false);
        setShow(true);
    };

    useEffect(() => {
        if (edit) {
            setCompanyName(data.companyName || '');
            setWebsite(data.website || '');
            setBank(data.bank || '');
            setIban(data.iban || '');
            setBic(data.bic || '');
            setTaxNumber(data.taxNumber || '');
            setTaxOffice(data.taxOffice || '');
        }
    }, [edit, data]);

    return (
        <div>
            {show && (
                <>
                    <p>Firmenname: {data.companyName ? data.companyName : 'Noch nicht angegeben'}</p>
                    <p className="settingsLogoContainer">
                        <span>Logo:</span>
                        {data.photo ? (
                            <img src={data.photo} alt="Logo" className="settingsLogo" />
                        ) : (
                            'Noch nicht angegeben'
                        )}
                    </p>
                    <p>Website: {data.website ? data.website : 'Noch nicht angegeben'}</p>
                    <p>Bank: {data.bank ? data.bank : 'Noch nicht angegeben'}</p>
                    <p>IBAN: {data.iban ? formatIban(data.iban) : 'Noch nicht angegeben'}</p>
                    <p>BIC: {data.bic ? data.bic : 'Noch nicht angegeben'}</p>
                    <p>Steuernummer: {data.taxNumber ? data.taxNumber : 'Noch nicht angegeben'}</p>
                    <p>Finanzamt: {data.taxOffice ? data.taxOffice : 'Noch nicht angegeben'}</p>
                    <Button buttonValue='Bearbeiten' onClick={handleEdit} />
                </>
            )}
            {edit && (
                <form onSubmit={handleSubmit} className="settingsForm">
                    <Label labelFor='companyName' labelValue='Firmenname: ' />
                    <Input inputId='companyName' inputName='companyName' inputType='text' borderColor="black" inputValue={companyName} onChange={(e) => setCompanyName(e.target.value)} /><br />
                    <Label labelFor='photo' labelValue='Logo: ' />
                    <Input inputId='photo' inputName='photo' inputType='file' borderColor="black" onChange={(e) => setPhoto(e.target.files[0])} /><br />
                    {photo && <img src={URL.createObjectURL(photo)} alt="Logo Vorschau" className='settingsLogo' />}<br/>
                    <Label labelFor='website' labelValue='Website: ' />
                    <Input inputId='website' inputName='website' inputType='text' borderColor="black" inputValue={website} onChange={(e) => setWebsite(e.target.value)} /><br />
                    <Label labelFor='bank' labelValue='Bankinstitut: ' />
                    <Input inputId='bank' inputName='bank' inputType='text' borderColor="black" inputValue={bank} onChange={(e) => setBank(e.target.value)} /><br />
                    <Label labelFor='iban' labelValue='IBAN: ' />
                    <Input inputId='iban' inputName='iban' inputType='text' borderColor="black" inputValue={iban} onChange={(e) => setIban(formatIban(e.target.value))} maxLength={27} /><br />
                    <Label labelFor='bic' labelValue='BIC: ' />
                    <Input inputId='bic' inputName='bic' inputType='text' borderColor="black" inputValue={bic} onChange={(e) => setBic(e.target.value)} /><br />
                    <Label labelFor='taxNumber' labelValue='Steuernummer: ' />
                    <Input inputId='taxNumber' inputName='taxNumber' inputType='text' borderColor="black" inputValue={taxNumber} onChange={(e) => setTaxNumber(e.target.value)} /><br />
                    <Label labelFor='taxOffice' labelValue='Finanzamt: ' />
                    <Input inputId='taxOffice' inputName='taxOffice' inputType='text' borderColor="black" inputValue={taxOffice} onChange={(e) => setTaxOffice(e.target.value)} /><br />
                    <Button buttonType='button' buttonValue='Abbrechen' onClick={handleCancel} />
                    <Button buttonType='submit' buttonValue='Abschließen' />
                </form>
            )}
        </div>
    );
}

export default Company;